import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import CommonTable from "../../common-components/common-tables/CommonTable";
import { BinIcon2, EditIcon2 } from "../../../images/icons/icons";
import { NoImage } from "../../../exports/Images";

const CarryItemsList = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  userInfoData,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { addonCarryItems, addonCarryItemsLoading } = useSelector(
    (state) => state.plans
  );

  const handleDeleteCarryItem = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: "/addon/carryitems/delete",
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(
              response?.message || "Carry item deleted successfully!"
            );
            callFunction();
          } else {
            toast.error(response?.message || "Cannot delete carry item!");
          }
        } catch (error) {
          toast.error(error?.message || "Failed to delete carry item");
        }
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure you want to delete this carry item?`
      );
    } else {
      toast.error("UID required!");
    }
  };

  const tbColumns = [
    {
      dataField: "label",
      text: "Label",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.label || "NA"}</span>;
      },
    },
    {
      dataField: "category_name",
      text: "Category",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.category_name || "NA"}</span>;
      },
    },
    {
      dataField: "image",
      text: "Image",
      formatter: (_, row) => {
        return (
          <div className="tb-img lightBorderRadiusImg">
            <img
              src={row?.image || NoImage}
              alt={row?.label || "NA"}
              className="image"
              style={{ cursor: row?.image ? "pointer" : "default" }}
            />
          </div>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-badge ${
              row?.status === "active" ? "tb-badge-success" : "tb-badge-stuck"
            }`}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "edit_carry_item",
                rowData: row,
              }))
            }
          >
            <EditIcon2 />
          </button>

          <button
            className="actionBtn icon delete"
            onClick={() => {
              const filters = {
                uid: row?.uid || "",
              };
              handleDeleteCarryItem(filters);
            }}
          >
            <BinIcon2 />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="common-table-container mt15">
      <CommonTable
        tableData={addonCarryItems?.data || []}
        tablePagination={addonCarryItems?.pagination || []}
        tableColumns={tbColumns}
        isPage={isPage}
        setIsPage={setIsPage}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
        isLoading={addonCarryItemsLoading}
      />
    </div>
  );
};

export default CarryItemsList;
